import Repository from './Repository'

export default {
  getQuestionsResponses () {
    return Repository.public().get(
      '/claim/questions'
    )
  },
  postAnswerQuestions (id, params) {
    return Repository.public().post(
      '/claim/user/' + id + '/answers', params
    )
  }
}
